import lifeAreasData from "../resources/lifeAreas";

export default function (areaKey: string) {
  const { title, icon } = lifeAreasData[areaKey];
  return `${title} ${icon}`;
}
